import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { AlertModalData, AlertsTabType } from '../reducer/alerts.reducer'
import { RootState } from '../store'
import { UserAlert, UserAlertLog } from '../proto/generated/nexus'
import { OrdersStateType } from '../reducer/orders.reducer'

const state = (state: RootState) => state


export const selectAlertsTab = createDraftSafeSelector(state, (store: RootState) => store.alertsStore.alertsTab as AlertsTabType)
export const selectAlertModalData = createDraftSafeSelector(state, (store: RootState) => store.alertsStore.alertModalData as AlertModalData)
export const selectAlertsLoading = createDraftSafeSelector(state, (store: RootState) => store.alertsStore.loading as boolean)
export const selectUserAlerts = createDraftSafeSelector(state, (store: RootState) => store.alertsStore.alerts as UserAlert[])
export const selectFiredAlerts = createDraftSafeSelector(state, (store: RootState) => {
    const firedAlerts = store.alertLogsStore.logs as UserAlertLog[]
    const orderAlerts = (store.ordersStore as OrdersStateType).recentFiredOrderAlerts
    const recentFiredAlerts = store?.alertLogsStore?.recentFiredAlerts as string[]
    return {
        firedAlerts,
        orderAlerts,
        recentFiredAlerts
    }
})